module.exports = __webpack_public_path__ + "static/img/img_hezuohuoban.e7b7db4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/index/img_hezuohuoban.png
// module id = sjk2
// module chunks = 0